// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3fdbbe1a","553":"d83b1974"}[chunkId] + ".chunk.js";
};